// extracted by mini-css-extract-plugin
var _1 = "Jqfv2URsun19oscoORgQ";
var _2 = "Jb_yyOraG9Cb_oDl1T56";
var _3 = "Nyk5z3hNYMh7CjmXUF_o";
var _4 = "Ba0_RmLnoRjThoo3saLj";
var _5 = "#000000";
var _6 = "#76F366";
var _7 = "#EB8632";
var _8 = "#ECC834";
var _9 = "#21FC87";
var _a = "#EA4A30";
var _b = "#C7EA45";
var _c = "#272B2B";
var _d = "#BDBDBD";
var _e = "#7D7D7D";
var _f = "#6A0DAD";
var _10 = "#3A65FF";
var _11 = "#4A90E2";
var _12 = "#ffffff";
var _13 = "ixQ0DhMDQkcL6hUA4xec";
var _14 = "1200px";
var _15 = "992px";
var _16 = "1366px";
var _17 = "768px";
var _18 = "1475px";
var _19 = "576px";
var _1a = "1600px";
var _1b = "320px";
var _1c = "2500px";
var _1d = "JbQFRcXEA64gjwdSLnxs";
export { _1 as "active-media-preview", _2 as "assigneeListEmpty", _3 as "assigneeListLoader", _4 as "base-link", _5 as "colorBlack", _6 as "colorGradeEX", _7 as "colorGradeFR", _8 as "colorGradeGD", _9 as "colorGradeOU", _a as "colorGradePR", _b as "colorGradeVG", _c as "colorNeutral", _d as "colorNeutralLighest", _e as "colorNeutralLight", _f as "colorNonOwnerSweetLine", _10 as "colorOwnerSweetLine", _11 as "colorRegularLinks", _12 as "colorWhite", _13 as "reset-button", _14 as "screenlg", _15 as "screenmd", _16 as "screenml", _17 as "screensm", _18 as "screenxlg", _19 as "screenxs", _1a as "screenxxlg", _1b as "screenxxs", _1c as "screenxxxlg", _1d as "single-page-responsive-font-size" }
export default { "active-media-preview": _1, "assigneeListEmpty": _2, "assigneeListLoader": _3, "base-link": _4, "colorBlack": _5, "colorGradeEX": _6, "colorGradeFR": _7, "colorGradeGD": _8, "colorGradeOU": _9, "colorGradePR": _a, "colorGradeVG": _b, "colorNeutral": _c, "colorNeutralLighest": _d, "colorNeutralLight": _e, "colorNonOwnerSweetLine": _f, "colorOwnerSweetLine": _10, "colorRegularLinks": _11, "colorWhite": _12, "reset-button": _13, "screenlg": _14, "screenmd": _15, "screenml": _16, "screensm": _17, "screenxlg": _18, "screenxs": _19, "screenxxlg": _1a, "screenxxs": _1b, "screenxxxlg": _1c, "single-page-responsive-font-size": _1d }
